import { render, staticRenderFns } from "./panelAudience.vue?vue&type=template&id=0b75aed6&scoped=true&lang=pug"
import script from "./panelAudience.vue?vue&type=script&lang=js"
export * from "./panelAudience.vue?vue&type=script&lang=js"
import style0 from "./panelAudience.vue?vue&type=style&index=0&id=0b75aed6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b75aed6",
  null
  
)

export default component.exports